import { purgePwa } from '../common/PwaControls';
import React, { useEffect, useRef } from 'react';
import { useAuth, useUser } from '@clerk/clerk-react';
import { registerClerkGetToken, clearClerkGetToken } from '@/uptk/core/api/clerkTokenProvider';

export default function ClerkInitializer() {
  const { getToken, isSignedIn, sessionClaims } = useAuth();
  const { user } = useUser();
  const previouslySignedIn = useRef(false);

  const extractList = (value: unknown): string[] => {
    if (Array.isArray(value)) {
      return value.filter((item): item is string => typeof item === 'string');
    }
    if (value && typeof value === 'object') {
      return Object.keys(value as Record<string, unknown>).filter((key) => Boolean((value as Record<string, unknown>)[key]));
    }
    return [];
  };

  useEffect(() => {
    if (getToken) {
      registerClerkGetToken(getToken as any);
    }
    return () => {
      clearClerkGetToken();
    }
  }, [getToken]);

  useEffect(() => {
    if (typeof isSignedIn === 'boolean') {
      localStorage.setItem('clerk_is_signed_in', String(isSignedIn));
      if (!isSignedIn) {
        void purgePwa().catch(() => window.dispatchEvent(new Event('geode:pwa-purge-failed')));
        localStorage.removeItem('clerk_user_name');
        localStorage.removeItem('clerk_user_id');
        localStorage.removeItem('clerk_roles');
      }
    }

    previouslySignedIn.current = isSignedIn === true;
    if (user) {
      const displayName =
        user.fullName ||
        user.primaryEmailAddress?.emailAddress ||
        user.username ||
        '';
      if (displayName) {
        localStorage.setItem('clerk_user_name', displayName);
      }
      localStorage.setItem('clerk_user_id', user.id);

      const claims = sessionClaims as Record<string, unknown> | null;
      const roles = [
        ...extractList(claims?.roles),
        ...extractList(claims?.appRoles),
        ...extractList(claims?.app_roles),
        ...extractList(user.publicMetadata),
        ...extractList(user.unsafeMetadata),
      ];
      if (roles.length > 0) {
        localStorage.setItem('clerk_roles', JSON.stringify(roles));
      }
    }
  }, [isSignedIn, sessionClaims, user]);

  return null;
}
